import React from 'react'
import PileExecutedStatusChangerView from '../PileExecutedStatusChanger/View'
import PileExecutedCardItem from './Components/Item'

import useViewModel from './ViewModel'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const ProjectPileExecutedListView: React.FC = () => {
  const { projectMachineOptions, data, projectId, onScan, onChangeStatus, onPrint } = useViewModel()

  return (
    <React.Fragment>
      <PileExecutedStatusChangerView />

      <div className='card'>
        <div className='card-header'>
          <div className='card-title'>รายการรวมตอกเสาสำเร็จ</div>
          <div className='card-toolbar'></div>
        </div>

        <div className='card-body'>
          <div className='row g-10'>
            {data.map((item: any) => (
              <PileExecutedCardItem
                key={item.id}
                {...item}
                masterMachines={projectMachineOptions}
                onScan={onScan}
                onPrint={onPrint}
                onChangeStatus={onChangeStatus}
              />
            ))}
          </div>
        </div>
        <div className='text-center'>
          <Link className='mx-1' to={'/project/' + projectId + '/pile-execution'}>
            <Button variant='info'>ย้อนกลับ</Button>
          </Link>
          <Link className='mx-1' to={'/project/' + projectId + '/overview'}>
            <Button variant='info'>ไปยังโครงการ</Button>
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectPileExecutedListView
